import packageInfo from '../../package.json';
import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { Image, Button } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';
import { getStorage, ref as storageRef, getDownloadURL } from 'firebase/storage';
import logo from '../Images/logo_white.png';
import ikon_byggnader from '../Images/Meny-ikoner/ikon_byggnader.png';
import ikon_ekonomi from '../Images/Meny-ikoner/ikon_ekonomi.png';
import ikon_forvaltning from '../Images/Meny-ikoner/ikon_forvaltning.png';
import ikon_tidslinje from '../Images/Meny-ikoner/ikon_tidslinje.png';
import ikon_projekt from '../Images/Meny-ikoner/ikon_projekt.png';
import ikon_analys from '../Images/Meny-ikoner/ikon_analys.png';
import NavigationButton from "./NavigationButton";
import "./Navigation.css"

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = getAuth();
    const database = getDatabase();
    const storage = getStorage();

    const [userName, setUserName] = useState('\u00A0');
    const [organizationName, setOrganizationName] = useState('\u00A0');
    const [customerLogo, setCustomerLogo] = useState<string|undefined>(undefined);

    useEffect(() => {
        const user = auth.currentUser;
        if (user == null) {
            navigate('/');
        } else {
            const userNameRef = ref(database, `users/userList/${user.uid}/name`);
            get(userNameRef)
                .then((snapshot) => {
                    if (snapshot.exists()) {
                        setUserName(snapshot.val());
                    } else {
                        setUserName('Användarnamn saknas');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching user name:', error);
                    setUserName('Användarnamn saknas');
                });

            const organizationRef = ref(database, 'global/instanceName');
            get(organizationRef)
                .then((snapshot) => {
                    if (snapshot.exists()) {
                        setOrganizationName(snapshot.val());
                    } else {
                        setOrganizationName('Odefinierad');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching organization name:', error);
                    setOrganizationName('Odefinierad');
                });

            const customerLogoRef = storageRef(storage, 'global/logo/logo_square.png');
            getDownloadURL(customerLogoRef)
                .then((url) => {
                    setCustomerLogo(url);
                })
                .catch((error) => {
                    console.error('Error fetching customer logo:', error);
                });
        }
    }, [auth.currentUser, navigate, database, storage]);

    const logOut = async () => {
        await signOut(auth)
            .then(() => {
                navigate('/home');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <div className="navigation-container">
            <div className="sidebar">
                <div className="logo-container">
                    <Image
                        src={logo}
                        className="logo"
                        onClick={() => navigate('/')}
                    />
                </div>

                <NavigationButton
                    label="Byggnader"
                    iconPath={ikon_byggnader}
                    isActive={location.pathname === '/map' || location.pathname === '/'}
                    onClick={() => navigate('/map')}
                />
                <NavigationButton
                    label="Ekonomi"
                    iconPath={ikon_ekonomi}
                    isActive={location.pathname === '/economy'}
                    onClick={() => navigate('/economy')}
                />
                <NavigationButton
                    label="Förvaltning"
                    iconPath={ikon_forvaltning}
                    isActive={location.pathname === '/building-checks'}
                    onClick={() => navigate('/building-checks')}
                />
                <NavigationButton
                    label="Tidslinje"
                    iconPath={ikon_tidslinje}
                    isActive={location.pathname === '/timeline'}
                    onClick={() => navigate('/timeline')}
                />
                <NavigationButton
                    label="Projekt"
                    iconPath={ikon_projekt}
                    isActive={location.pathname === '/projects'}
                    onClick={() => navigate('/projects')}
                />
                <NavigationButton
                    label="Analys"
                    iconPath={ikon_analys}
                    isActive={location.pathname === '/analysis'}
                    onClick={() => navigate('/analysis')}
                />

                <div 
                    className={`settings-button ${location.pathname === '/settings' ? 'active' : ''}`} 
                    onClick={() => navigate('/settings')}
                >
                    <img
                        src={'/Images/settings.png'}
                        alt="Settings"
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                </div>

                <div className="customer-logo-container">
                    {
                        customerLogo &&
                        <img
                            src={customerLogo}
                            className="customer-logo"
                            alt="Customer Logo"
                        />
                    }
                </div>

                <span 
                    className="user-name clickable-user-name" 
                    onClick={() => navigate('/profile')}
                    title="Klicka för att öppna profilinställningar"
                >
                    {userName}
                </span>
                <span className="user-organization">{organizationName}</span>

                <Button
                    variant="outline-light"
                    className="white-link-button logout-button"
                    onClick={logOut}
                >
                    Logga ut
                </Button>

                <div className="version-info">
                    <span className="version-text">
                        v{packageInfo.version}
                    </span>
                </div>

            </div>

            <div className="main-content">
                <Outlet />
            </div>
        </div>
    );
};

export default Navigation;